import {
  MANAGE_SURVEY_TABS,
  ManageSurveyTab,
  ManageSurveyTabKey,
} from '../../constants/manage-survey-tabs.constants';
import { classifySurvey } from '../../models/survey-classifier';
import { Survey } from '../../models/survey.model';

export interface ManageSurveyTabVisibilityContext {
  readonly hasHealthMetrics: boolean;
  // Tabs the caller has already resolved as inaccessible via `canAccess`
  // (role/access-level/buyer-config rules) — `survey/utils` must not depend
  // on `user-settings-data-access`, so the feature layer computes this set
  // with `canAccess`/`CanAccessDirective` and passes the plain result in.
  readonly deniedTabKeys: ReadonlySet<ManageSurveyTabKey>;
}

const DATA_DRIVEN_VISIBILITY: Partial<
  Record<
    ManageSurveyTabKey,
    (survey: Survey, hasHealthMetrics: boolean) => boolean
  >
> = {
  MULTI_COUNTRY: (survey) => classifySurvey(survey).isMcqb,
  TRACKER: (survey) => classifySurvey(survey).isTracker,
  GROUPED: (survey) => classifySurvey(survey).isGrouped,
  MARGIN_MAX: (survey) => survey.isMarginMaxEnabled,
  // Real per-KPI health data comes from a dedicated `/health` endpoint, not
  // `survey.healthCheck` (unreliable on the survey-details response) — see
  // `ManageSurveyHealthCheckComponent`.
  HEALTH_CHECKS: (_survey, hasHealthMetrics) => hasHealthMetrics,
};

export function visibleManageSurveyTabs(
  survey: Survey,
  context: ManageSurveyTabVisibilityContext,
): ManageSurveyTab[] {
  return MANAGE_SURVEY_TABS.filter(
    (tab) =>
      !context.deniedTabKeys.has(tab.key) &&
      (DATA_DRIVEN_VISIBILITY[tab.key] ?? (() => true))(
        survey,
        context.hasHealthMetrics,
      ),
  );
}
